{
  "add_banner": "Agregar banner",
  "change_avatar": "Cambiar avatar",
  "change_banner_image": "Cambia la imagen del estandarte",
  "remove_banner": "Eliminar banner",
  "remove_banner_image": "Eliminar la imagen del banner",
  "search_unsplash_banner": "Buscar Unsplash para la imagen de banner",
  "profile": "Perfil",
  "profile_folder": "Carpeta de perfil"
}